export const validateEmail = (email: string): boolean => {
  const emailParts = email.split('@');
  const [local] = emailParts;

  if (!BANNED_EMAILS.includes(local)) {
    return true;
  }

  return false;
};

export const BANNED_EMAILS = [
  'admin',
  'agency',
  'agent',
  'billing',
  'careers',
  'claims',
  'client-services',
  'clients',
  'clientservices',
  'commercial',
  'commissions',
  'contact',
  'contactus',
  'customerservice',
  'editor',
  'events',
  'feedback',
  'general',
  'hello',
  'help',
  'info',
  'inquiries',
  'insurance',
  'insure',
  'jobs',
  'marketing',
  'media',
  'membership',
  'news',
  'newsletter',
  'office',
  'orders',
  'partnerships',
  'policies',
  'policy',
  'press',
  'privacy',
  'processing',
  'producer',
  'quote',
  'quotes',
  'renewal',
  'renewals',
  'reservations',
  'returns',
  'sales',
  'service',
  'services',
  'suggestions',
  'support',
  'supportteam',
  'survey',
  'team',
  'underwriting',
  'webmaster',
];
